import { Navigate } from "react-router-dom";
import { useStudentCohorts } from "../student/StudentCohortContext";
import { StudentCohortDetailSkeleton } from "../student/StudentCohortDetailSkeleton";

/** Redirect /cohorts to the student's first enrolled cohort. */
export default function StudentCohortsRedirectPage() {
  const { cohorts, loading, hasCohorts } = useStudentCohorts();

  if (loading && !hasCohorts) {
    return <StudentCohortDetailSkeleton />;
  }

  if (!hasCohorts) {
    return <Navigate to="/join" replace />;
  }

  const first = cohorts[0]?.cohortId;
  if (!first) {
    return <Navigate to="/join" replace />;
  }

  return <Navigate to={`/cohorts/${first}`} replace />;
}
